import { combineClasses, Trans, Translation } from "@citychallenge/core";
import { FC } from "react";

import { Spinner } from "../spinner";
import styles from "./button.module.scss";

export interface ButtonProps
  extends React.DetailedHTMLProps<
    React.ButtonHTMLAttributes<HTMLButtonElement>,
    HTMLButtonElement
  > {
  children?: Translation | React.ReactNode;
  loading?: boolean;
  theme?: "default" | "light" | "faded";
  anim?: "appear-up";
}

export const Button: FC<ButtonProps> = ({
  className,
  loading,
  children,
  theme = "default",
  disabled,
  anim,
  ...props
}) => {
  const buttonContent =
    children instanceof Translation ? <Trans>{children}</Trans> : children;
  return (
    <button
      {...props}
      disabled={disabled || loading}
      className={combineClasses(styles.button, className, styles[theme])}
      tabIndex={props.tabIndex === undefined ? -1 : props.tabIndex}
      data-anim={anim ? anim : undefined}
    >
      {loading && <Spinner size="small" />}
      {!loading && buttonContent}
    </button>
  );
};
